export default function MobileSection() {
  return (
    <section className="w-full bg-white py-14 md:py-20 lg:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl mx-auto text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 bg-dark-teal-50 text-dark-teal-500 text-xs font-semibold rounded-full mb-4">
            Mobil Deneyim
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-deep-navy-500 leading-tight mb-4">
            Mobilde hızlı, sade ve güvenli kullanım
          </h2>
          <p className="text-sm md:text-base text-gray-500 max-w-xl mx-auto">
            Platform mobil öncelikli olarak tasarlandı. Terapistler ve spa işletmeleri için ayrılmış, optimize edilmiş mobil deneyim.
          </p>
        </div>

        {/* Phone Mockups */}
        <div className="flex flex-col lg:flex-row items-center justify-center gap-6 md:gap-8 lg:gap-10">
          {/* Phone 1: Therapist Dashboard */}
          <PhoneMockup title="Terapist Dashboard">
            <div className="space-y-3">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-7 h-7 rounded-full bg-dark-teal-100 flex items-center justify-center text-dark-teal-500 text-[10px] font-bold">A</div>
                <div>
                  <div className="text-[10px] font-semibold text-deep-navy-500">Hoş Geldiniz</div>
                  <div className="text-[9px] text-gray-400">Antalya · Masaj</div>
                </div>
              </div>
              <div className="bg-dark-teal-50 rounded-lg p-2.5">
                <div className="text-[9px] text-gray-500 mb-1">Yeni Eşleşme</div>
                <div className="flex items-center gap-2">
                  <div className="w-6 h-6 rounded-full bg-dark-teal-200 flex items-center justify-center text-[8px] text-dark-teal-600 font-bold">S</div>
                  <div className="flex-1 min-w-0">
                    <div className="text-[10px] font-medium text-deep-navy-500 truncate">Spa Merkezi Ataköy</div>
                    <div className="text-[8px] text-gray-400">Uyum: 94%</div>
                  </div>
                  <div className="text-[8px] px-1.5 py-0.5 bg-dark-teal-500 text-white rounded-full">Yeni</div>
                </div>
              </div>
              <div className="bg-gray-50 rounded-lg p-2.5">
                <div className="text-[9px] text-gray-500 mb-1">İstatistikler</div>
                <div className="flex gap-2">
                  <div className="flex-1 bg-white rounded-md p-2 text-center">
                    <div className="text-[10px] font-bold text-dark-teal-500">3</div>
                    <div className="text-[7px] text-gray-400">Eşleşme</div>
                  </div>
                  <div className="flex-1 bg-white rounded-md p-2 text-center">
                    <div className="text-[10px] font-bold text-soft-gold-600">2</div>
                    <div className="text-[7px] text-gray-400">Talep</div>
                  </div>
                </div>
              </div>
            </div>
          </PhoneMockup>

          {/* Phone 2: Spa Dashboard */}
          <PhoneMockup title="Spa Dashboard">
            <div className="space-y-3">
              <div className="flex items-center justify-between mb-3">
                <div className="text-[10px] font-semibold text-deep-navy-500">Terapist Havuzu</div>
                <div className="text-[8px] text-gray-400">12 Kredi</div>
              </div>
              <div className="flex items-center gap-2 p-2 bg-off-white rounded-lg border border-gray-100">
                <div className="w-6 h-6 rounded-full bg-soft-gold-100 flex items-center justify-center text-[8px] text-soft-gold-700 font-bold">M</div>
                <div className="flex-1 min-w-0">
                  <div className="text-[9px] font-medium text-deep-navy-500 truncate">M.Y. · Cilt Bakımı</div>
                  <div className="text-[7px] text-gray-400">İstanbul · 87% Uyum</div>
                </div>
                <div className="w-5 h-5 rounded-full bg-soft-gold-100 flex items-center justify-center">
                  <i className="ri-heart-3-line text-[8px] text-soft-gold-600" />
                </div>
              </div>
              <div className="flex items-center gap-2 p-2 bg-off-white rounded-lg border border-gray-100">
                <div className="w-6 h-6 rounded-full bg-dark-teal-100 flex items-center justify-center text-[8px] text-dark-teal-600 font-bold">A</div>
                <div className="flex-1 min-w-0">
                  <div className="text-[9px] font-medium text-deep-navy-500 truncate">A.K. · Masaj</div>
                  <div className="text-[7px] text-gray-400">Antalya · 94% Uyum</div>
                </div>
                <div className="w-5 h-5 rounded-full bg-dark-teal-50 flex items-center justify-center">
                  <i className="ri-heart-3-line text-[8px] text-dark-teal-400" />
                </div>
              </div>
              <div className="bg-deep-navy-500 rounded-lg p-2.5 mt-2">
                <div className="text-[8px] text-gray-300 mb-1">Personel İhtiyacı</div>
                <div className="flex items-center gap-2">
                  <div className="text-[10px] text-white font-medium truncate">Antalya Şubesi</div>
                  <div className="text-[7px] px-1.5 py-0.5 bg-soft-gold-500/20 text-soft-gold-400 rounded-full">Açık</div>
                </div>
              </div>
            </div>
          </PhoneMockup>

          {/* Phone 3: Chat Screen */}
          <PhoneMockup title="Güvenli Chat">
            <div className="flex flex-col h-full">
              {/* Chat Header */}
              <div className="flex items-center gap-2 pb-2 mb-2 border-b border-gray-100">
                <div className="w-6 h-6 rounded-full bg-dark-teal-100 flex items-center justify-center text-[8px] text-dark-teal-600 font-bold">A</div>
                <div>
                  <div className="text-[9px] font-medium text-deep-navy-500">A.K.</div>
                  <div className="text-[7px] text-gray-400">Masaj · Antalya</div>
                </div>
              </div>
              {/* Messages */}
              <div className="flex-1 space-y-2">
                <div className="bg-gray-100 rounded-lg p-2 self-start max-w-[85%]">
                  <p className="text-[8px] text-gray-600 leading-relaxed">Merhaba, pozisyon hakkında bilgi alabilir miyim?</p>
                </div>
                <div className="bg-dark-teal-50 rounded-lg p-2 self-end ml-auto max-w-[85%]">
                  <p className="text-[8px] text-dark-teal-700 leading-relaxed">Tabii, detayları paylaşabilirim.</p>
                </div>
                <div className="bg-gray-100 rounded-lg p-2 self-start max-w-[85%]">
                  <p className="text-[8px] text-gray-600 leading-relaxed">Çalışma saatleri nasıl?</p>
                </div>
                <div className="bg-dark-teal-50 rounded-lg p-2 self-end ml-auto max-w-[85%]">
                  <p className="text-[8px] text-dark-teal-700 leading-relaxed">Tam zamanlı, esnek vardiya.</p>
                </div>
              </div>
              {/* Input hint */}
              <div className="mt-2 p-1.5 bg-soft-gold-50 rounded-lg border border-soft-gold-200">
                <p className="text-[7px] text-soft-gold-700 text-center">Telefon ve adres bilgisi onay sonrası paylaşılır</p>
              </div>
            </div>
          </PhoneMockup>
        </div>
      </div>
    </section>
  );
}

function PhoneMockup({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="flex flex-col items-center gap-3">
      <div className="text-xs font-semibold text-deep-navy-500">{title}</div>
      <div className="relative w-[200px] h-[400px] bg-deep-navy-500 rounded-[32px] p-2 shadow-soft-xl">
        {/* Notch */}
        <div className="absolute top-2 left-1/2 -translate-x-1/2 w-16 h-5 bg-deep-navy-500 rounded-b-xl z-10" />
        {/* Screen */}
        <div className="w-full h-full bg-white rounded-[24px] overflow-hidden flex flex-col">
          <div className="h-6 bg-white shrink-0" />
          <div className="flex-1 p-3 overflow-hidden">
            {children}
          </div>
          {/* Bottom bar */}
          <div className="h-8 bg-white border-t border-gray-50 flex items-center justify-around px-4 shrink-0">
            <i className="ri-home-5-line text-[12px] text-dark-teal-500" />
            <i className="ri-search-line text-[12px] text-gray-300" />
            <i className="ri-message-3-line text-[12px] text-gray-300" />
            <i className="ri-user-3-line text-[12px] text-gray-300" />
          </div>
        </div>
      </div>
    </div>
  );
}